import { Component, inject, OnDestroy, OnInit } from "@angular/core";
import { ActivatedRoute, RouterLink, RouterLinkActive, RouterOutlet } from "@angular/router";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { TranslateModule } from "@ngx-translate/core";

@Component({
  selector: "app-competitions-tab",
  standalone: true,
  imports: [TranslateModule, RouterLink, RouterLinkActive, RouterOutlet],
  templateUrl: "./competitions-tab.component.html",
  styleUrl: "./competitions-tab.component.scss",
})
export class CompetitionsTabComponent implements OnInit, OnDestroy {
  readonly destroy$ = new Subject<void>();
  route = inject(ActivatedRoute);

  ngOnInit() {}

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
